module.exports = __webpack_public_path__ + "img/014-tie.532998ee.svg";